import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DummyImage = process.env.PUBLIC_URL + "/assets/images/landingpage/dummyImage.svg";

const BlogCard = ({ post = null, size = 3 }) => {
  const { t } = useTranslation();

  if (!post) return null;

  const slug = post.slug.replace("blogapi", "blog") || "";

  return (
    <Col md={size} className="mb-3">
      <Link to={slug} style={{ textDecoration: "none" }}>
        <div className="blogCard" style={{ height: "100%" }}>
          <img src={DummyImage} alt="" style={{ width: "100%", maxHeight: 200, objectFit: "cover", borderRadius: 10, marginBottom: 16 }} />
          <h2 className="blogCardTitle truncate-two-lines">{post.title}</h2>
          <p style={{ color: "#6b7280", fontSize: 14, lineHeight: "22px", marginTop: 8, flexGrow: 1 }}>{post.description}</p>
          <span
            style={{ display: "inline-block", marginTop: 16, color: "#038edc", fontWeight: 700, fontSize: 14, fontFamily: "Montserrat, sans-serif" }}
          >
            {t("Blog.More")} →
          </span>
        </div>
      </Link>
    </Col>
  );
};

export default BlogCard;
